import { inject, Injectable } from '@angular/core';
import {
  AdobeDataLayerPayload,
  AdobeDataPages,
} from '../models/adobe-data-layer.model';
import { MlbStatsConnectionService } from './mlb-stats.service';
import { ConfigurationService } from './configuration.service';
import { lastValueFrom, Subject } from 'rxjs';
import { SaleEvent } from '@core/models';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdobeDataLayerService {
  configurationService = inject(ConfigurationService);
  mlbStatsConnectionService = inject(MlbStatsConnectionService);
  pageEventSubject = new Subject<AdobeDataPages>();

  get teamId() {
    return Number(this.configurationService.configuration.teamId);
  }

  push(data: AdobeDataLayerPayload): void {
    console.log('Adobe Data Layer Push');
    console.table(data);
    const adobeDataLayer = (window as any).adobeDataLayer || [];
    return adobeDataLayer.push(data);
  }

  async getGamePK(): Promise<string> {
    try {
      const response = await lastValueFrom(
        this.mlbStatsConnectionService.getSchedule()
      );
      let gamePk = '';
      response.dates.forEach(date => {
        if (gamePk) {
          return;
        }
        const game = date.games.find(game => {
          const isHomeTeamMatching = game.teams.home.team.id === this.teamId;
          const isAwayTeamMatching = game.teams.away.team.id === this.teamId;

          return isHomeTeamMatching || isAwayTeamMatching;
        });

        if (game) {
          gamePk = game.gamePk.toString();
        }
      });

      return gamePk;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  getEventId() {
    const eventId = localStorage.getItem('adobe-data-layer-eventId');
    return eventId || '';
  }

  setEventId(eventId: number | string) {
    localStorage.setItem('adobe-data-layer-eventId', eventId.toString());
  }

  getEvent(): SaleEvent {
    const event = localStorage.getItem('adobe-data-layer-event');
    return event ? JSON.parse(event) : ({} as SaleEvent);
  }

  setEvent(event: SaleEvent) {
    localStorage.setItem('adobe-data-layer-event', JSON.stringify(event));
  }

  getMatchupFull() {
    const event = this.getEvent();
    return `${event.description}-${event.date}`;
  }
}
